import Utils from './utils';
import Feature from './feature';
import UiInteraction from './ui_interaction';

const Search = {
	_keydownHandler: null,

	get input() {
		return document.getElementById('search_input');
	},

	get listItems() {
		return document.querySelectorAll('.uw-search-results-item[role="option"]');
	},

	get submitButton() {
		return document.querySelector('.uw-search-submit');
	},

	updateActiveOption(index) {
		Search.listItems.forEach((li) => li.setAttribute('aria-selected', 'false'));
		Search.listItems[index].setAttribute('aria-selected', 'true');
		Search.input.setAttribute('aria-activedescendant', Search.listItems[index].id);
		Search.listItems[index].scrollIntoView({ block: 'nearest' });
	},

	clearActiveOption() {
		Search.listItems.forEach((li) => li.setAttribute('aria-selected', 'false'));
		Search.input.setAttribute('aria-activedescendant', '');
	},

	debouncedSearch: Utils.debounce(() => {
		Search.search(Search.input.value);
	}, 200),

	search: function (term) {
		// remove aria described by as soon as search begins
		// to prevent overly noisy UI
		Search.input.removeAttribute('aria-describedby');
		let url = W.api_root + 'search.html?';
		const params = { s: term };
		const urlSearchParams = new URLSearchParams(params);
		const resultsContainer = document.querySelector('.uw-search-results');
		const mapMenu = document.querySelector('.map-menu');
		const loadingIndicator = mapMenu.querySelector('.loading');

		loadingIndicator.classList.add('show');

		if (typeof gtag !== 'undefined') {
			gtag('event', 'search', { event_category: 'Search', event_label: term });
		}

		url = url + urlSearchParams;

		fetch(url)
			.then((response) => {
				if (!response.ok) {
					throw new Error(`HTTP error! Status: ${response.status}`);
				}
				return response.text();
			})
			.then((response) => {
				loadingIndicator.classList.remove('show');

				response = response.replace(/<!--[\s\S]*?-->/g, '');

				mapMenu.classList.add('is-searching');
				resultsContainer.classList.add('show');
				Search.input.setAttribute('aria-expanded', 'true');
				if ('' === response) {
					if (Search.input.value !== '') {
						response = '<ul><li class="no-results">No results found</li></ul>';
					} else {
						mapMenu.classList.remove('is-searching');
						resultsContainer.classList.remove('show');
					}
				}
				resultsContainer.innerHTML = response.replace(/<!--[\s\S]*?-->/g, '');

				Search.listItems.forEach((item) => {
					item.addEventListener('click', (e) => {
						e.preventDefault();
						mapMenu.classList.remove('is-searching');

						const option = e.currentTarget;
						const feature = Feature.fromSearch({
							searchable_id: option.dataset.mapObjectId,
							searchable_type: option.dataset.model,
						});

						if (feature) {
							UiInteraction.clearAllPopups();
							UiInteraction.fetchAndAddFeature(feature, { origin: 'search' });
							setTimeout(() => {
								resultsContainer.classList.remove('show');
							}, 200);
						}
						// If we hit a tag, trigger the checkbox in the dom
						else if (option.dataset.model === 'Tag') {
							document.getElementById('tag-layer-' + option.dataset.mapObjectId).click();
						}
					});
				});

				// Remove previous keydown handler to prevent listener accumulation
				if (Search._keydownHandler) {
					document.removeEventListener('keydown', Search._keydownHandler);
				}

				let activeIndex = -1;

				Search._keydownHandler = (e) => {
					if (!resultsContainer.classList.contains('show')) return;

					if (e.key === 'ArrowDown') {
						e.preventDefault();
						if (activeIndex < Search.listItems.length - 1) {
							activeIndex++;
							Search.updateActiveOption(activeIndex);
						}
					} else if (e.key === 'ArrowUp') {
						e.preventDefault();
						if (activeIndex > 0) {
							activeIndex--;
							Search.updateActiveOption(activeIndex);
						} else if (activeIndex === 0) {
							activeIndex = -1;
							Search.clearActiveOption();
						}
					} else if (e.key === 'Enter' && activeIndex >= 0) {
						e.preventDefault();
						Search.listItems[activeIndex].click();
					} else if (e.key === 'Escape') {
						e.preventDefault();
						resultsContainer.classList.remove('show');
						mapMenu.classList.remove('is-searching');
						Search.input.setAttribute('aria-expanded', 'false');
						activeIndex = -1;
						Search.clearActiveOption();
					}
				};

				document.addEventListener('keydown', Search._keydownHandler);
			});
	},

	addListeners: () => {
		if (!Search.input) return;
		Search.input.addEventListener('input', Search.debouncedSearch);

		Search.input.addEventListener('focus', (e) => {
			const searchTerm = e.target.value;
			const resultsContainer = document.querySelector('.uw-search-results');

			// if search results container is not visible but there is a search
			// term in the input, run search again
			if (
				resultsContainer.offsetWidth === 0 &&
				resultsContainer.offsetHeight === 0 &&
				!/^\s*$/.test(searchTerm)
			) {
				Search.search(searchTerm);
			}
		});
	},
};

Search.addListeners();

export default Search;
